import { Box } from '@mui/material';
import { BaseAccordion } from '../../../../../Accordion/BaseAccordion';
import { ColumnMapping } from '../InstrumentIdentifiers/components/ColumnMapping/ColumnMapping';
import { ValidationBadge } from '../../ValidationBadge/ValidationBadge';
import { LabelAutocompleteInput } from '../../../../../Infra/LabelAutocompleteInput/LabelAutocompleteInput';
import { SingleColumnWithLabelSectionProps } from './types';
import { useSingleColumnWithLabelSection } from './useSingleColumnWithLabelSection';
import './SingleColumnWithLabelSection.scss';

export const SingleColumnWithLabelSection = (
  props: SingleColumnWithLabelSectionProps
) => {
  const {
    title,
    sectionId,
    templateId,
    instrumentType,
    availableHeaders,
    expanded,
    onChange,
  } = props;

  const {
    labels,
    selectedColumn,
    handleAddTransferLabel,
    handleRemoveTransferLabel,
    validationResult,
  } = useSingleColumnWithLabelSection(props);
  return (
    <BaseAccordion
      title={title}
      expanded={expanded}
      onChange={onChange}
      badge={<ValidationBadge validationResult={validationResult} />}
    >
      <Box className="singleColumnWithLabelSection">
        {/* Column Mapping - Single column only */}
        <ColumnMapping
          templateId={templateId}
          instrumentType={instrumentType}
          sectionId={sectionId}
          availableHeaders={availableHeaders}
          singleMode={true}
        />

        {/* Transfer Label Input */}
        <LabelAutocompleteInput
          showCheckboxes
          selectedColumn={selectedColumn}
          labels={labels}
          onAdd={handleAddTransferLabel}
          onRemove={handleRemoveTransferLabel}
          placeholder="Select or type transfer label values..."
        />
      </Box>
    </BaseAccordion>
  );
};
